import { getRetailerCurrentSubscription } from "../api/RetailerSubscription";
import { getCurrentSubscription } from "../api/subscription";

const getSubscriptionDetail = async (businessType: string | null, shopId: string | null) => {
    try {
        const response = businessType === 'Retail'
            ? await getRetailerCurrentSubscription(shopId) : await getCurrentSubscription();
        if (response) {
            sessionStorage.removeItem('planDetail');
            sessionStorage.setItem('planDetail', JSON.stringify(response.payload.plan));
        }
    } catch (error: any) {
        console.log('unable to reset plan data in session storage ')
    }
};

export {
    getSubscriptionDetail
}